import React from 'react';
import './Column.css';

const Column = () => (
  <div className="column">
    <div className="groove" />
    <div className="groove" />
    <div className="groove" />
    <div className="groove" />
    <div className="groove" />
    <div className="head" />
    <div className="head2" />
  </div>
);

export default Column;
